const Config = {
    appId: 'web-v1', 
    appKey: 'f55b967cad863f21a385e904dceae165', 
  };
  
  export default Config;
  